<template>
  <div class="has-bottom">
    <div class="page-main">
      <el-row class="step-row">
        <div class="spaceAround">
          <div
            v-for="(item, index) in stepList"
            :key="index"
            :style="'width:' + spanCount + '%'"
            :span="spanCount"
            class="auth-step"
            :class="{
              'is-active': active === index,
            }"
            @click="changeStep(index)"
          >
            <span>{{ index + 1 }}. {{ item.name }}</span>
            <div class="auth-step-before" />
            <div class="auth-step-after" />
          </div>
        </div>
      </el-row>
      <keep-alive>
        <component
          :is="stepList[active].comp"
          ref="initComp"
          :area="pageData.region"
          @changeAsset="changeAsset"
          @changeRegion="changeRegion"
        />
      </keep-alive>
    </div>
    <page-bottom>
      <template>
        <div class="page-btns">
          <loading-btn
            type="primary"
            :label="active == stepList.length - 1 ? 'Submit' : 'Next'"
            @clickHandle="next"
          />
        </div>
      </template>
    </page-bottom>
    <successDialog ref="successDialog" @close="successClose" />
  </div>
</template>

<script>
import BusinessKYC from '../businessKYC/index.vue'
import IdentityKYC from '../IdentityKYC/index.vue'
import SelectAsset from './selectAsset/selectAsset.vue'
import successDialog from './successDialog.vue'
export default {
  components: {
    BusinessKYC,
    IdentityKYC,
    SelectAsset,
    successDialog
  },
  data() {
    return {
      active: 0,
      stepList: [],
      pageData: {
        asset: ['1'],
        region: undefined
      },
      BusinessKYC: null
    }
  },
  computed: {
    spanCount() {
      return 100 / this.stepList.length
    }
  },
  created() {
    this.changeAsset()
    this.init()
    console.log(this.pageData)
  },
  methods: {
    init() {
      const annualInfo = this.$store.getters.annualInfo
      console.log('annualInfo', annualInfo)
      if (annualInfo.producer && annualInfo.producer.kyb && !annualInfo.producer.kyc) {
        const kybdata = annualInfo.producer.kybdata
          ? JSON.parse(annualInfo.producer.kybdata.replace(/\//g, ''))
          : {}
        this.pageData.region = kybdata.CountryCode
        this.pageData.asset = ['1']
        this.active = 2
      } else if (
        annualInfo.producer &&
        annualInfo.producer.kyb &&
        annualInfo.producer.kyc &&
        this.getAnnualWellCount(annualInfo) === 0
      ) {
        const kybdata = annualInfo.producer.kybdata
          ? JSON.parse(annualInfo.producer.kybdata.replace(/\//g, ''))
          : {}
        this.pageData.region = kybdata.CountryCode
        this.BusinessKYC = kybdata
        this.pageData.asset = ['1']
        this.active = 3
      }
    },
    getAnnualWellCount(annualInfo) {
      const pointWellCount = (annualInfo.pointList || []).reduce((count, item) => {
        return count + ((item.wells && item.wells.length) || 0)
      }, 0)
      return pointWellCount + (annualInfo.wellList || []).length
    },
    next(btn) {
      this.btn = btn
      try {
        this.$refs['initComp']
          .submit()
          .then((res) => {
            if (this.stepList[this.active].comp === 'BusinessKYC') {
              this.BusinessKYC = res
            }

            this.btn && this.btn.closeLoad()
            if (res.type === 'end') {
              this.$refs.successDialog.open()
            }
            if (this.active < this.stepList.length - 1) {
              this.active++
            }
          })
          .catch((err) => {
            console.log(err)
            this.btn && this.btn.closeLoad()
          })
      } catch (e) {
        console.log(e)
        this.btn && this.btn.closeLoad()
      }
    },
    changeStep(index) {
      // this.active = index;
    },
    changeAsset(asset) {
      this.pageData.asset = asset || this.pageData.asset
      this.stepList = [
        {
          name: 'Select Asset',
          comp: 'SelectAsset'
        },
        {
          name: 'Business Verification',
          comp: 'BusinessKYC'
        },
        {
          name: 'Personal Verification',
          comp: 'IdentityKYC'
        }
      ]
    },
    changeRegion(region) {
      this.pageData.region = region
    },
    successClose(type) {
      if (type === 'add') {
        this.$router.push('/wellManagement/myWells')
      } else {
        this.$router.push('/')
      }
      setTimeout(() => {
        location.reload()
      }, 800)
    }
  }
}
</script>
<style scoped lang="scss">
.el-steps.el-steps--simple {
  padding: 13px 2%;
}
.con {
  margin: 80px auto;
  text-align: center;
  .header {
    font-size: 24px;
    color: #000;
    font-weight: bold;
  }
}
.step-row {
  border: 0.01rem solid #dcdee0;
  background: #fff;
  margin-bottom: 0.16rem;
  overflow: hidden;
}
.auth-step {
  text-align: center;
  padding: 0.19rem 0;
  background: #fff;
  background-size: 100% 100%;
  font-size: 0.18rem;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  position: relative;
  box-sizing: border-box;

  .auth-step-before {
    height: 100%;
    width: 0.3rem;
    position: absolute;
    top: 0;
    left: -0.3rem;

    border-top: 0.3rem solid transparent;
    border-bottom: 0.3rem solid transparent;
    border-left: 0.3rem solid transparent;
    z-index: 8;
  }
  .auth-step-after {
    height: 100%;
    width: 0.3rem;
    position: absolute;
    top: 0;
    right: -0.3rem;
    border-top: 0.3rem solid transparent;
    border-bottom: 0.3rem solid transparent;
    border-left: 0.3rem solid transparent;
    z-index: 1;
  }

  &.is-active {
    background: #1E54E7;
    background-size: 100% 100%;
    color: #fff;

    .auth-step-before {
      border-top: 0.3rem solid #1E54E7;
      border-bottom: 0.3rem solid #1E54E7;
      border-left: 0.3rem solid transparent;
    }
    .auth-step-after {
      border-top: 0.3rem solid transparent;
      border-bottom: 0.3rem solid transparent;
      border-left: 0.3rem solid #1E54E7;
    }
  }
}
</style>
